/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Rest_Api_S1_TitleInputs */

const en_guide_json_rest_api_s1_title = /** @type {(inputs: Guide_Json_Rest_Api_S1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON in HTTP Requests`)
};

const ko_guide_json_rest_api_s1_title = /** @type {(inputs: Guide_Json_Rest_Api_S1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HTTP 요청에서의 JSON`)
};

const ja_guide_json_rest_api_s1_title = /** @type {(inputs: Guide_Json_Rest_Api_S1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HTTPリクエストにおけるJSON`)
};

/**
* | output |
* | --- |
* | "JSON in HTTP Requests" |
*
* @param {Guide_Json_Rest_Api_S1_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_rest_api_s1_title = /** @type {((inputs?: Guide_Json_Rest_Api_S1_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Rest_Api_S1_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_rest_api_s1_title(inputs)
	if (locale === "ko") return ko_guide_json_rest_api_s1_title(inputs)
	return ja_guide_json_rest_api_s1_title(inputs)
});